import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ClubSubscribe } from '../../../shared/components/club-subscribe/club-subscribe';

@Component({
  selector: 'app-club',
  standalone: true,
  imports: [CommonModule, RouterLink, ClubSubscribe],
  templateUrl: './club.html',
  styleUrl: './club.css',
})
export class Club {}